import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=0596e57a&scoped=true&"
import script from "./examine-detail.vue?vue&type=script&lang=js&"
export * from "./examine-detail.vue?vue&type=script&lang=js&"
import style0 from "./examine-detail.vue?vue&type=style&index=0&id=0596e57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596e57a",
  null
  
)

export default component.exports